import { useAuthStore } from '@/store/auth';
import { useSmeAuthStore } from '@/store/sme/sme-auth';
import msApi from '@/utils/msApi';
import { patch } from '@/utils/request';

export type PlatformEventData = {
  event_name: string;
  platform?: string;
  metadata?: {
    [key: string]: string | string[] | number | number[] | boolean | boolean[] | null;
  };
};

export default function (useSme?: boolean) {
  const authStore = useAuthStore();
  const smeAuthStore = useSmeAuthStore();

  return {
    async trackEvent({ event_name, platform = 'adv', metadata }: PlatformEventData) {
      const profileId = useSme ? smeAuthStore.smeProfile.id : authStore.profile?.id;
      const user_id = profileId ?? '';
      const meta = { ...metadata, user_id };

      try {
        const response = await msApi.msPost('/platform-analytics/event', {
          event_name,
          platform,
          metadata: meta,
        });

        return response;
      } catch (err) {
        const error = err as Error;
        throw new Error(error.message);
      }
    },
    async logLastId(id: any) {
      try {
        const response = await patch('/user/merchants/last_company', {
          company_id: id,
        });

        return response;
      } catch (err) {
        const error = err as Error;
        throw new Error(error.message);
      }
    },
  };
}

/* Composable to be used like this

  import usePlatformAnalytics from '@/composables/usePlatformAnalytics';

  const { trackEvent } = usePlatformAnalytics();

  const platformEventData: PlatformEventData = {
    event_name: 'FetchTest',
    platform: 'adv',
    metadata: {
      'a key': 'the value',
    },
  };

  trackEvent({
    event_name: 'CampaignCreated',
    platform: 'adv',
    metadata: {
      company_id: company_id.value,
      campaign_id: campaignStore.campaignForm.id as string,
      mode: campaignStore.influencerSelectionMode,
    },
  });

*/
